import BirdForm from './bird_form'

export default {
  BirdForm
}
